export class AuthenticationModel {
  statusCode: string;
  issuerUrl: string;
  issuerKey: string;
  userMessageTitle: string;
  userMessageDesc: string;
  dataErrorWithRetryBtn: boolean;
  
  constructor(
    statusCode: string, 
    issuerUrl: string, 
    issuerKey: string,
    userMessageTitle: string,
    userMessageDesc: string,
    dataErrorWithRetryBtn: boolean
  ) {
    this.statusCode = statusCode;
    this.issuerUrl = issuerUrl;
    this.issuerKey = issuerKey;
    this.userMessageTitle = userMessageTitle;
    this.userMessageDesc = userMessageDesc;
    this.dataErrorWithRetryBtn = dataErrorWithRetryBtn;
  }
}
